'use strict';

var Reflux     = require('reflux'),
    TagActions = require('js/shared/actions/tag-actions.js'),
    _        = require('underscore'),
    PROGRAMS = require('js/shared/utils/programs.js'),
    HACKATHONS = require('js/shared/utils/events.js'),
    SKILLS = require('js/shared/utils/skills.js');

var tagsList = ['institutions', 'hackathons', 'events', 'academic_program', 'skills', 'locations'];

module.exports = Reflux.createStore({

    init: function () {

        this.tagResults = {};
        this.tags = {};
        tagsList.forEach(function(tagGroup) {
            this.tagResults[tagGroup] = [];
            this.tags[tagGroup] = {};
        }.bind(this));

        this.listenTo(TagActions.searchTags.completed, this.onSearchTags);
        this.listenTo(TagActions.searchLocations.completed, this.onSearchLocations);
        this.listenTo(TagActions.searchAcademicPrograms, this.onSearchPrograms);
        this.listenTo(TagActions.searchSkills, this.onSearchSkills);
        this.listenTo(TagActions.searchEvents, this.onSearchEvents);
        this.listenTo(TagActions.addCustomTag, this.onAddCustomTag);
    },

    getState: function() {
        return {
            dataIsLoaded: true,
            tagResults: this.tagResults,
            tags: this.tags
        };
    },

    onAddCustomTag: function(tagId, customTag) {
        this.tags[tagId][customTag] = {
            id: customTag,
            name: customTag
        };
        this.trigger('addCustomTag');
    },

    onSearchLocations: function(resp) {
    },

    onSearchTags: function(resp) {
        var tagId = resp.req.url.match(/https?\:\/\/.+\/v1\/search\/(.+)\?.*/)[1];
        var query = decodeURIComponent(resp.req._query[0].slice(2));

        var getId;
        var getResult;
        if (tagId === "events") {
            getId = function(event) {
                return event.name;
            };
            getResult = getId;
        }
        else {
            getId = function(tag) {
                return tag.id;
            };
            getResult = function(tag) {
                return tag;
            };
        }
        this.tagResults[tagId][query] = _.map(resp.body, getResult);
        resp.body.forEach(function(result) {
            this.tags[tagId][getId(result)] = getResult(result);
        }.bind(this));


        this.trigger('searchTags');
    },

    onSearchPrograms: function(tagId, query) {
        // NOTE: a naive scoring algorithm is used here due to browser performance issues with fuzzy
        // if matches the query substring with the list, lower index of match beginning => higher score
        // e.g. "comp" matches a max score against "Computer Science"
        // and a lower score against "information technology and computers"
        var maxScore = query.length;
        var actualQuery = query.toLowerCase();
        var results = _.chain(PROGRAMS.lowerCase)
                       .map(function(program) {
                        var idx = program.indexOf(actualQuery);
                        var score;
                        if (idx === -1) {
                            score = 0;
                        }
                        else {
                            score = (maxScore - idx)/maxScore;
                        }
                        return {
                            name: program,
                            score: score
                        };
                       })
                       .filter(function(result) { return result.score !== 0; })
                       .sortBy('score')
                       .reverse()
                       .pluck('name')
                       .first(20)
                       .map(function(elem) {
                        return PROGRAMS.lowerCaseMapping[elem];
                       })
                       .value();


        this.tagResults[tagId][query] = results;

        results.forEach(function(result) {
            this.tags[tagId][result] = result;
        }.bind(this));

        this.trigger('searchPrograms');
    },

    onSearchEvents: function(tagId, query) {
        // NOTE: a naive scoring algorithm is used here due to browser performance issues with fuzzy
        // if matches the query substring with the list, lower index of match beginning => higher score
        // e.g. "comp" matches a max score against "Computer Science"
        // and a lower score against "information technology and computers"
        var maxScore = query.length;
        var actualQuery = query.toLowerCase();
        var results = _.chain(HACKATHONS.lowerCaseHackathons)
                       .map(function(program) {
                        var idx = program.indexOf(actualQuery);
                        var score;
                        if (idx === -1) {
                            score = 0;
                        }
                        else {
                            score = (maxScore - idx)/maxScore;
                        }
                        return {
                            name: program,
                            score: score
                        };
                       })
                       .filter(function(result) { return result.score !== 0; })
                       .sortBy('score')
                       .reverse()
                       .pluck('name')
                       .first(20)
                       .map(function(elem) {
                        return HACKATHONS.lowerCaseHackathonsMapping[elem];
                       })
                       .value();


        this.tagResults[tagId][query] = results;

        results.forEach(function(result) {
            this.tags[tagId][result] = result;
        }.bind(this));

        this.trigger('searchEvents');
    },

    onSearchSkills: function(tagId, query) {
        var maxScore = query.length;
        var actualQuery = query.toLowerCase();
        var results = _.chain(SKILLS.lowerCase)
                       .map(function(skill) {
                        var idx = skill.indexOf(actualQuery);
                        var score;
                        if (idx === -1) {
                            score = 0;
                        }
                        else {
                            score = (maxScore - idx)/maxScore;
                        }
                        return {
                            name: skill,
                            score: score
                        };
                       })
                       .filter(function(result) { return result.score !== 0; })
                       .sortBy('score')
                       .reverse()
                       .pluck('name')
                       .first(20)
                       .map(function(elem) {
                        return SKILLS.lowerCaseMapping[elem];
                       })
                       .value();


        this.tagResults[tagId][query] = results;

        results.forEach(function(result) {
            this.tags[tagId][result] = result;
        }.bind(this));

        this.trigger('searchSkills');
    },

});



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/stores/tagsearch-store.js
 ** module id = 237
 ** module chunks = 0 1 6 9
 **/